import styles from "./style.module.scss";
import { useRef, forwardRef, useImperativeHandle, useEffect, useState } from "react";
import DynamicForm, { DynamicFormRef, setCurrencySymbolForMoneyInputs } from "@mavichpe/dynamic-forms";
import InvoicesPaymentFormConfig from "./form";
import { CurrencyIdPubSub, CurrencyUpdatePubSubPayload } from "@utils/pubsubs/PubSub";
import { CurrencyApi } from "@/api/CurrencyApi";
import { setCurrency } from "@/store/slices/currencySlides";
import { useAppDispatch } from "@/store/hooks";
import { removeFunctionFromObject } from "@utils/Utils";
import { CURRENCIES_SYMBOLS } from "@utils/Constants";
import debounce from "debounce";
import { showAlert } from "@utils/Alert";
import { InvoicesRecibeDataType } from "@/formTypes/InvoicesRecibeFormDataType";

type InvoicesPaymentFormProps = {
  onPaymentSubmit: (data: InvoicesRecibeDataType) => void;
  onPaymentDateChange: (projectDate: string) => void;
  defaultData?: InvoicesRecibeDataType;
  innerForm?: boolean;
  recibeTotal: number;
};

// Usamos forwardRef para permitir ref externo
const InvoicesPaymentForm = forwardRef<DynamicFormRef, InvoicesPaymentFormProps>(
  (props, ref) => {
    const { onPaymentSubmit, innerForm = false, defaultData,
      recibeTotal, onPaymentDateChange } = props;
    const dispatch = useAppDispatch();
    const [currencySymbol, setCurrencySymbol] = useState<string>("");

    const internalRef = useRef<DynamicFormRef>(null);
    useImperativeHandle(ref, () => internalRef.current as DynamicFormRef, []);


    useEffect(() => {
      const unsubscribe = CurrencyIdPubSub.subscribe(setFormCurrency);
      return () => {
        unsubscribe();
      };
    }, []);

    const setFormCurrency = async (payload: CurrencyUpdatePubSubPayload) => {
      const { currencyId } = payload;
      const priceData = await CurrencyApi.get(currencyId);
      if (priceData.currency_id) {
        dispatch(setCurrency(removeFunctionFromObject(priceData)));

        setCurrencySymbol(CURRENCIES_SYMBOLS[priceData.currency_id])
        if (internalRef) {
          internalRef.current?.setFormValue("multiple",
            {
              currencyId,
              exchange_rate: priceData.exchange_rate

            }, "multipleData")
        }
      }
    }

    const getFormConfig = () => {
      let config = {
        ...InvoicesPaymentFormConfig
      }

      if (currencySymbol) {
        config = setCurrencySymbolForMoneyInputs(InvoicesPaymentFormConfig, currencySymbol)
      }

      return config
    }

    const checkReciboFullPayment = debounce((amount: string) => {
      const newRecibeAmount = Number(amount);
      if (newRecibeAmount > recibeTotal) {
        showAlert("danger", "El monto total del recibo no puede ser superior al monto total Pendiente")
        internalRef.current?.setFormValue("monto", recibeTotal, "decimal")
      }
    }, 300);

    const onInputChange = (name: keyof InvoicesRecibeDataType, value: any) => {
      if (name == "monto") {
        checkReciboFullPayment(`${value}`)
      } else if (name == "fecha") {
        onPaymentDateChange(`${value}`)
      }
    }

    return (
      <DynamicForm<InvoicesRecibeDataType>
        externalFormState={defaultData}
        ref={internalRef}
        innerForm={innerForm}
        formConfig={getFormConfig()}
        onInputChange={onInputChange}
        onSubmit={onPaymentSubmit}
      />
    );
  }
);

export default InvoicesPaymentForm;